<template>
  <div class="desktop-date-with-arrows">
    <div class="leftarrow" :class="{'-show': showLeftArrow}" @click="leftArrowAction">
      <UIIcon name="chevron-left" />
    </div>
    <div class="date-grid">
      <div class="date" v-for="date in dates" :key="date" @click="setStartingTime(date)" :class="{ '-active': dateActive(date) }">
        <div class="dow f8">{{ makeDateParts(date).dow }}</div>
        <div class="number f2">{{ makeDateParts(date).date }}</div>
        <div class="month f8">{{ makeDateParts(date).month }}</div>
      </div>
    </div>
    <div class="rightarrow -show" @click="rightArrowAction">
      <UIIcon name="chevron-right" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import moment from 'moment-timezone';
import DateHelper from '@/core/shared/helpers/DateHelper';
import UIIcon from '@/core/shared/components/ui/UIIcon';

@Component({
  components: {
    UIIcon,
  },
  props: {
    startTime: {
      type: String,
      required: true,
    },
    currentTime: {
      type: String,
      required: true,
    },
  },
})
export default class DesktopDate extends Vue {
  dayInView = null;

  get dates () {
    const dates = [];
    for (var i = 0; i < 7; i++) {
      dates.push(moment(this.dayInView).add(i, 'days').hour(12).minute(0).second(0).format());
    }
    return dates;
  }

  get showLeftArrow () {
    return !DateHelper.dateMatch(this.dayInView, this.currentTime);
  }

  created () {
    this.dayInView = moment(this.startTime).format();
  }

  leftArrowAction () {
    this.dayInView = moment(this.dayInView).subtract(7, 'days').format();
  }

  rightArrowAction () {
    this.dayInView = moment(this.dayInView).add(7, 'days').format();
  }

  dateActive (date) {
    return DateHelper.dateMatch(date, this.startTime);
  }

  makeDateParts (date) {
    const momentDate = moment(date);
    return {
      dow: momentDate.format('dddd'),
      date: momentDate.format('DD'),
      month: momentDate.format('MMM'),
    };
  }

  setStartingTime (date) {
    if (DateHelper.dateMatch(date, this.currentTime)) {
      this.$emit('setStartingTimeNow');
    } else {
      const startTimeMoment = moment(this.startTime);
      const dateMoment = moment(date).set({
        hours: startTimeMoment.hours(),
        minutes: startTimeMoment.minutes(),
        seconds: startTimeMoment.seconds(),
      });
      this.$emit('setStartingTime', dateMoment.format());
    }
  }
}
</script>

<style scoped lang="postcss">
@import 'core/shared/styles';

.desktop-date-with-arrows {
  position: relative;
  display: flex;
  align-items: center;

  & .leftarrow,
  & .rightarrow {
    position: absolute;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;
    cursor: pointer;

    &.-show {
      opacity: 0.5;
      pointer-events: all;

      &:hover {
        opacity: 1;
      }
    }

    & svg {
      width: 3rem;
      height: 3rem;
    }
  }

  & .leftarrow {
    left: -3rem;
  }

  &  .rightarrow {
    right: -3rem;
  }

  & .date-grid {
    flex: 1 1 100%;
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    align-items: center;
    grid-gap: var(--spacingSm);

    & .date {
      text-align: center;
      border: 0.1rem solid var(--colorGeyser);
      border-radius: var(--radius);
      padding: var(--spacingXS);
      cursor: pointer;
      transition: background-color 0.3s ease;
      word-wrap: break-word;
      word-break: break-all;

      @media (--desktopXL) {
        padding: var(--spacingSm);
      }

      & .number {
        margin: var(--spacingXS);
      }

      &.-active {
        background-color: var(--colorSlate);
        color: var(--colorWhite);
        & .dow,
        & .month {
          color: var(--colorWhite);
        }
        &:hover {
          background-color: var(--colorSlate);
        }
      }

      &:hover {
        background-color: var(--colorCasper);
      }
    }
  }
}
</style>
